import {
  Button,
  ButtonProps,
  Icon,
  IconButton,
  IconButtonProps,
} from '@chakra-ui/react';
import { Plus, Trash } from '@phosphor-icons/react';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';
import useToasts from '@/lib/toasts';

export const TopLevelCreateNewButton = (props: ButtonProps) => (
  <Button
    colorScheme="primary"
    variant="solid"
    iconSpacing="2"
    leftIcon={<Plus />}
    size="md"
    borderRadius="6px"
    {...props}
  />
);

export const AddButton = (props: ButtonProps) => (
  <Button
    leftIcon={<Plus weight="bold" size="16" />}
    colorScheme="primary"
    variant="alt"
    size="sm"
    alignSelf="center"
    {...props}
  />
);

export const DeleteButton = (props: ButtonProps) => (
  <Button
    mx="auto"
    leftIcon={<Trash weight="bold" size="16" />}
    colorScheme="red"
    size="sm"
    {...props}
  />
);

export const RemoveButton = ({
  children,
  ...props
}: Omit<IconButtonProps, 'children' | 'aria-label'> & { children: string }) => (
  <IconButton
    icon={<Icon as={Trash} width={5} height={5} />}
    aria-label={children}
    {...props}
  />
);

export const SubmitButton = (props: ButtonProps) => {
  const { pristine, submitting, valid } = useFormState();
  const { errorToast } = useToasts();
  const { t } = useTranslation('backoffice');
  const { onClick, ...restProps } = props;

  const invalidFormInfo = useCallback(() => {
    if (!valid) {
      errorToast({
        description: t(
          'invalid_form_fields',
          'Lomaketta ei voida tallentaa koska se sisältää virheitä. Tarkista virheelliset kentät ja yritä uudelleen.',
        ),
      });
      return false;
    }
    return undefined;
  }, [errorToast, t, valid]);

  return (
    <Button
      size="md"
      colorScheme="primary"
      type="submit"
      isLoading={submitting}
      isDisabled={pristine}
      onClick={onClick || invalidFormInfo}
      {...restProps}
    />
  );
};
